import { Box, Button, Grid, Modal, Typography } from "@mui/material";
import React, { useState } from "react";
import PlaceIcon from "@mui/icons-material/Place";
import MailIcon from "@mui/icons-material/Mail";
import PhoneIcon from "@mui/icons-material/Phone";
import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import CloseIcon from "@mui/icons-material/Close";
import MaterialTextFieldComponent from "../textField/MaterialTextFieldCmp";
import { Formik } from "formik";
import { object, string } from "yup";
import { useMutation } from "react-query";
import {
  DeleteSupplierAddress,
  EditSupplierAddress,
} from "../../services/report.service";
import { v4 } from "uuid";
interface Props {
  address: string;
  email: string;
  telNumbers: string;
  supplierAddressId: number;
  setReloadOnDel: any;
  setReloadOnEdit: any;
}

const deactiveUserStyle = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",

  minWidth: {
    xs: 250,
    sm: 300,
    md: 400,
    lg: "400px",
  },
  maxHeight: "70vh",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  overflow: "auto",
  overflowX: "hidden",
  paddingRight: "3vh",
  paddingTop: "3vh",
  // direction: "ltr",
  "&::-webkit-scrollbar": {
    width: 7,
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "#F9FAFC",
    border: "2px solid #DAE0E4",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#9AAFC4",
  },
};

const BranchesCard = ({
  address,
  email,
  telNumbers,
  supplierAddressId,
  setReloadOnDel,
  setReloadOnEdit,
}: Props) => {
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [editAddress, setEditAddress] = useState<boolean>();
  const [DeleteAddress, setDeleteAddress] = useState<boolean>();

  const initialValues: any = {
    address: address,
    email: email,
    telNumbers: telNumbers,
  };
  const branchesValidation = object().shape({
    address: string()
      .ensure()
      .required("لطفا آدرس را وارد نمایید.")
      .matches(/^(?!\s+$).*/, "لطفا آدرس را صحیح وارد نمایید")
      .max(500, "آدرس نباید بیشتر از 500 کاراکتر باشد."),
    email: string()
      .ensure()

      .max(250, "ایمیل نباید بیشتر از 250 کاراکتر باشد.")
      .email("لطفا ایمیل را صحیح وارد نمایید."),
    telNumbers: string()
      .ensure()
      .required("لطفا شماره تماس را وارد نمایید.")
      .matches(
        /(((0?9)|(\+?989))\d{2}\W?\d{3}\W?\d{4})|(\d{8})/,

        "لطفا شماره تماس را صحیح وارد نمایید"
      ),
  });

  const handleEditAddress = (values: any) => {
    EditSupplierAddressMutate({
      supplierId: null,
      supplierAddressId: supplierAddressId,
      address: values.address.trim(),
      email: values.email.trim(),
      telNumbers: values.telNumbers,
    });

    setOpenEditModal(false);
  };

  const { mutate: EditSupplierAddressMutate } = useMutation(
    EditSupplierAddress,
    {
      onSuccess: (data: boolean) => {
        if (data) {
          setEditAddress(data);
          setReloadOnEdit(v4());
        }
      },
      onError: () => {},
    }
  );

  const { mutate: DeleteSupplierAddressMutate } = useMutation(
    DeleteSupplierAddress,
    {
      onSuccess: (data: boolean) => {
        if (data) {
          setDeleteAddress(data);
          setReloadOnDel(v4());
        }
      },
      onError: () => {},
    }
  );

  return (
    <>
      <Box
        sx={{ border: "1px solid #DAE0E4" }}
        borderRadius={".5rem"}
        marginBottom={".6rem"}
      >
        <Grid
          container
          flexDirection={"column"}
          padding={"1.7rem"}
          gap={"10px"}
        >
          <Grid item xs={12}>
            <Grid container justifyContent={"space-between"}>
              {address && (
                <Grid item>
                  <Typography>
                    <PlaceIcon
                      style={{ color: "#1D4A87", marginLeft: "10px" }}
                      fontSize="large"
                    ></PlaceIcon>
                    {address}
                  </Typography>
                </Grid>
              )}
              <Grid item>
                <ModeEditOutlineOutlinedIcon
                  onClick={() => setOpenEditModal(true)}
                  style={{
                    color: "#1D4A87",
                    cursor: "pointer",
                    marginInline: "3px",
                  }}
                />
                <DeleteOutlineOutlinedIcon
                  onClick={() => setOpenDeleteModal(true)}
                  style={{
                    color: "#1D4A87",
                    cursor: "pointer",
                    marginInline: "3px",
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
          {email && (
            <Grid item xs={12}>
              <Typography>
                <MailIcon
                  style={{ color: "#1D4A87", marginLeft: "10px" }}
                  fontSize="large"
                ></MailIcon>
                {email}
              </Typography>
            </Grid>
          )}
          {telNumbers && (
            <Grid item xs={12}>
              <Typography>
                <PhoneIcon
                  style={{ color: "#1D4A87", marginLeft: "10px" }}
                  fontSize="large"
                ></PhoneIcon>
                {telNumbers}
              </Typography>
            </Grid>
          )}
        </Grid>
      </Box>

      {/* delete modal */}

      <div>
        <Modal
          open={openDeleteModal}
          onClose={() => setOpenDeleteModal(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={deactiveUserStyle}>
            <Box position={"relative"}>
              <Typography
                onClick={() => setOpenDeleteModal(false)}
                component={"p"}
                color={"red"}
                position={"absolute"}
                top={0}
                left={0}
                sx={{ cursor: "pointer" }}
              >
                <CloseIcon></CloseIcon>
              </Typography>
            </Box>
            <Typography
              component={"p"}
              display={"block"}
              textAlign={"center"}
              fontWeight={"bold"}
              marginY={"3rem"}
              fontSize={"14px"}
            >
              آیا از <span style={{ color: "#E6123D" }}>حذف کردن</span> اطلاعات
              تماس این
              <span style={{ color: "#E6123D" }}> شعبه </span> اطمینان دارید؟
            </Typography>
            <Grid container justifyContent={"center"} gap={"1rem"}>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={6}
                sx={{
                  backgroundColor: "#E6123D",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
                padding={"0.5rem"}
                maxWidth={"150px !important"}
              >
                <Typography
                  textAlign={"center"}
                  color={"#FFF"}
                  fontWeight={"bold"}
                  onClick={() => {
                    DeleteSupplierAddressMutate({
                      supplierAddressId: supplierAddressId,
                    });
                    setOpenDeleteModal(false);
                  }}
                >
                  حذف کردن شعبه
                </Typography>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={6}
                sx={{
                  backgroundColor: "#607D8B",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
                padding={"0.5rem"}
                maxWidth={"150px !important"}
              >
                <Typography
                  textAlign={"center"}
                  color={"#FFF"}
                  fontWeight={"bold"}
                  onClick={() => setOpenDeleteModal(false)}
                >
                  انصراف
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </Modal>
      </div>

      {/* edit modal */}
      <div>
        <Modal
          open={openEditModal}
          onClose={() => setOpenEditModal(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={deactiveUserStyle}>
            <Box position={"relative"}>
              <Typography
                onClick={() => setOpenEditModal(false)}
                component={"p"}
                color={"red"}
                position={"absolute"}
                top={0}
                left={0}
                sx={{ cursor: "pointer" }}
              >
                <CloseIcon></CloseIcon>
              </Typography>
            </Box>
            <Typography
              component={"p"}
              display={"block"}
              textAlign={"right"}
              fontWeight={"bold"}
              marginY={"3rem"}
              fontSize={"14px"}
              color={"#1D4A87"}
            >
              ویرایش اطلاعات کاربر
            </Typography>
            <Formik
              initialValues={initialValues}
              onSubmit={handleEditAddress}
              validateOnMount={true}
              validationSchema={branchesValidation}
            >
              {({
                handleSubmit,
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
              }) => (
                <form onSubmit={handleSubmit}>
                  <Grid
                    container
                    gap={1}
                    justifyContent={"space-between"}
                    alignItems={"center"}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      marginBottom={"15px"}
                    >
                      <MaterialTextFieldComponent
                        placeHolder={"آدرس"}
                        label={"آدرس"}
                        required={true}
                        name={"address"}
                        id={"address"}
                        autoFocus={true}
                        // value={address}
                        value={values.address}
                        onChange={handleChange}
                        helperText={touched.address ? errors.address : ""}
                        error={touched.address && Boolean(errors.address)}
                        onBlur={handleBlur}
                      />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={6}
                      lg={6}
                      marginBottom={"15px"}
                      maxWidth={"280px !important"}
                    >
                      <MaterialTextFieldComponent
                        placeHolder={"ایمیل"}
                        label={"ایمیل"}
                        name={"email"}
                        id={"email"}
                        value={values.email}
                        onChange={handleChange}
                        helperText={touched.email ? errors.email : ""}
                        error={touched.email && Boolean(errors.email)}
                        onBlur={handleBlur}
                        className={"user-edit-input"}
                      />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={6}
                      lg={6}
                      marginBottom={"15px"}
                      maxWidth={"280px !important"}
                    >
                      <MaterialTextFieldComponent
                        placeHolder={"شماره تماس"}
                        label={"شماره تماس"}
                        required={true}
                        name={"telNumbers"}
                        id={"telNumbers"}
                        inputProps={{ maxLength: 11 }}
                        value={values.telNumbers}
                        onChange={handleChange}
                        helperText={touched.telNumbers ? errors.telNumbers : ""}
                        error={touched.telNumbers && Boolean(errors.telNumbers)}
                        onBlur={handleBlur}
                        className={"user-edit-input"}
                        onKeyDown={(event) => {
                          if (event.code === "Space") event.preventDefault();
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    justifyContent={{
                      xs: "center",
                      sm: "center",
                      md: "end",
                      lg: "end",
                    }}
                    gap={"1rem"}
                    alignItems={"center"}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={12}
                      lg={6}
                      sx={{
                        borderRadius: "5px",
                        cursor: "pointer",
                      }}
                      padding={"0.5rem"}
                      maxWidth={"150px !important"}
                    >
                      <Button
                        fullWidth
                        type="submit"
                        variant="contained"
                        disabled={
                          (values.address === address &&
                            values.email === email &&
                            values.telNumbers === telNumbers) ||
                          !values.address ||
                          !values.telNumbers
                        }
                        className={
                          !values.address ||
                          !values.telNumbers ||
                          (values.address === address &&
                            values.email === email &&
                            values.telNumbers === telNumbers)
                            ? "btnForm disabledBtn"
                            : "btnForm SuccessDefault"
                        }
                      >
                        ثبت
                      </Button>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={12}
                      lg={6}
                      sx={{
                        borderRadius: "5px",
                        cursor: "pointer",
                      }}
                      padding={"0.5rem"}
                      maxWidth={"150px !important"}
                    >
                      <Button
                        fullWidth
                        variant="contained"
                        style={{
                          fontSize: "1rem",
                          color: "#fff",
                          height: "40px",
                          background: "#607D8B",
                        }}
                        onClick={() => setOpenEditModal(false)}
                      >
                        انصراف
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              )}
            </Formik>
          </Box>
        </Modal>
      </div>
    </>
  );
};

export default BranchesCard;
